<template>
  <div>
    <CCard>
      <CCardHeader>
        <CampaignViewHeader
          title="Appendix II"
          :disable-member-select="!selected_member || is_loading"
          :selected-member-id="selected_member"
          :update-member-id-function="changeMember"
          showAmountInfo
        />
      </CCardHeader>
      <CCardBody>
        <DotsLoader v-if="is_loading"/>
        <template v-else>
          <CRow>
            <CCol col="2">
              <label>GP CCR:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="max-width: 150px"
                v-model="selected_group_ccr"
              />
            </CCol>
            <CCol col="2">
              <label>Code CPT:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="max-width: 150px"
                v-model="selected_code_cpt"
              />
            </CCol>
            <CCol col="2">
              <label>code GTA:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="max-width: 150px"
                v-model="selected_code_gda"
              />
            </CCol>
            <CCol col="6" class="text-right">
              <CButton
                class="mz-button v2-mz-btn mr-2 mt-3"
                color="primary"
                @click="saveAnnexeII"
              >
                {{ $t('Save') }}
              </CButton>
              <CButton
                class="mz-button v2-mz-btn mr-2 mt-3"
                color="primary"
                @click="
                  $downloadFile({
                    url: download_url
                  })
                "
              >
                {{ $t('Download') }}
              </CButton>
            </CCol>
          </CRow>
          <CRow class="w-100 mt-5">
            <CCol
              v-for="branch_nav in branches_nav"
              class="text-center"
              :key="branch_nav.english"
            >
              <div
                :class="{'custom-border-bottom': compareNavObjects(branch_nav)}"
                class="mt-3 on-mouse-hover"
                @click="switchPage(branch_nav)"
              >
                {{ current_language === 'en' ? branch_nav.english : branch_nav.french }}
              </div>
            </CCol>
          </CRow>
          <CRow class="w-100 mt-5">
            <DotsLoader v-if="table_loading"/>
            <table-component
              v-else
              :show-number-of-lines="false"
              :columns="['branch_alias', 'police_number', 'insured_sum', 'issued_prime']"
              :headings="{
                branch_alias: $t('Departments detail'),
                police_number: $t('Nb of polices'),
                insured_sum: $t('Sum insured'),
                issued_prime: $t('Written premium')
              }"
              :filter-exclude-columns="['Indicator', 'value', 'branch_alias', 'police_number', 'insured_sum', 'issued_prime']"
              :sort-exclude-columns="['Indicator', 'value']"
              :display-columns-selector="false"
              :data="annexeii_data"
            >
              <template v-for="filter in Object.keys(filter_table_data)" :slot="`filter__${filter}`">
                <input
                  class="form-control mz-input"
                  :placeholder="`Filter By ${filter}`"
                  v-model="filter_table_data[filter].value"
                  @change="filterData()"
                />
              </template>

              <template slot="branch_alias" slot-scope="{ row }">
                {{ row.department }}
              </template>

              <template slot="police_number" slot-scope="{ row }">
                <CInput
                  :addInputClasses="addCustomClassToInput(row, 'police_number', 'issued_prime')"
                  type="number"
                  class="mr-2"
                  style="min-width: 100px"
                  :value="getNumericalValue(row.police_number)"
                  @focusout="(e) => updateItemValue(row.id_annexe_ii, 'police_number',  e)"
                />
              </template>

              <template slot="insured_sum" slot-scope="{ row }">
                <CInput
                  addInputClasses="text-right"
                  type="number"
                  class="mr-2"
                  style="min-width: 100px"
                  :value="getNumericalValue(row.insured_sum)"
                  @focusout="(e) => updateItemValue(row.id_annexe_ii, 'insured_sum', e)"
                />
              </template>

              <template slot="issued_prime" slot-scope="{ row }">
                <CInput
                  :addInputClasses="addCustomClassToInput(row, 'issued_prime', 'police_number')"
                  type="number"
                  class="mr-2"
                  style="min-width: 100px"
                  :value="getNumericalValue(row.issued_prime)"
                  @focusout="(e) => updateItemValue(row.id_annexe_ii, 'issued_prime', e)"
                />
              </template>

            </table-component>
          </CRow>
        </template>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import CampaignViewHeader from "@/components/CampaignViewHeader";
import {MemberService} from "@/services/members";
import {CampaignServices} from "@/services/campaigns";
import {AnnexIIService, ANNEXII_ENDPOINTS} from "@/services/annexii";
import {ActiveUser} from "@/services/user";
import {getNumericalValue} from '@/utils/helpers';

export default {
  name: "AnnexeIIView",
  components: {CampaignViewHeader},
  data() {
    return {
      getNumericalValue,
      download_url: '',
      is_loading: true,
      table_loading: true,
      members_options: [],
      selected_member: undefined,
      campaign_member: {},
      userData: ActiveUser.get(),
      annexeii_origin_data: [],
      annexeii_data: [],
      prev_campaign_member: {},
      branches_nav: [
        {
          english: "PERSONAL LINES",
          french: "PARTICULIERS"
        },
        {
          english: "PROFESSIONAL",
          french: "PROFESSIONNELS"
        },
        {
          english: "AGRICULTURAL",
          french: "AGRICOLES"
        },
        {
          english: "OTHER PROPERTY DAMAGES",
          french: "AUTRES DOMMAGES"
        },
      ],
      selected_view: {},
      current_language: this.$store.state.language,
      filter_table_data: {
        branch_alias: {
          value: '',
          field: 'department'
        },
        police_number: {
          value: '',
          field: 'police_number'
        },
        insured_sum: {
          value: '',
          field: 'insured_sum'
        },
        issued_prime: {
          value: '',
          field: 'issued_prime'
        },
      },
    }
  },
  computed: {
    selected_code_cpt() {
      return this.members_options.find(member => member.value === this.selected_member)?.code_cpt;
    },
    selected_code_gda() {
      return this.members_options.find(member => member.value === this.selected_member)?.code_gda;
    },
    selected_group_ccr() {
      return this.campaign_member?.group_ccr || '';
    },
    prev_group_ccr() {
      return this.prev_campaign_member?.group_ccr || ""
    },

  },
  async mounted() {
    this.is_loading = true;
    await this.getPreviousCampaignMember();
    await this.fetchData();
    this.is_loading = false;
  },
  methods: {
    addCustomClassToInput(row_data, valid_row, valid_neighbor_row) {
      let classArr = ['text-right']
      if ((row_data[valid_row] === 0 && row_data[valid_neighbor_row] > 0)) classArr.push('validation-default')
      return classArr
    },
    async filterData() {
      await this.filterAnnexeIIDataByView()
    },
    hasWhiteSpace(s) {
      return /\s/g.test(s);
    },
    formatValue(val) {
      if (typeof (val) === 'string' && this.hasWhiteSpace(val)) {
        val = val.replace(/\s+/g, '');
      }
      val = parseFloat(val)
      if (isNaN(val)) {
        return 0
      }
      else {
        return val
      }
    },
    updateItemValue(item_id, item_key, event) {
      const item = this.annexeii_origin_data.find(item => item.id_annexe_ii === item_id);
      const index = this.annexeii_origin_data.indexOf(item);
      this.annexeii_origin_data[index][item_key] = this.formatValue(event.target.value);
    },
    switchPage(nav_obj) {
      this.selected_view = nav_obj;
      this.filterAnnexeIIDataByView();
    },
    compareNavObjects(nav_obj) {
      return nav_obj.french === this.selected_view.french && nav_obj.english === this.selected_view.english
    },
    handlePrevGroupCCR(v) {
      this.prev_campaign_member.group_ccr = v
    },
    async getPreviousCampaignMember() {
      const {data} = await CampaignServices.fetchCampaignMember(this.$route.params.campaignId - 1, this.$route.params.id)
      this.prev_campaign_member = data
    },
    changeMember(member_id) {
      this.$router.push({name: 'Appendix II', params: {campaignId: this.$route.params.campaignId, id: member_id}});
    },
    async fetchData() {
      let members = await MemberService.getMembers();

      if (this.userData.role === 'User') {
        members = members.filter(
          (member) => member.email === this.userData.email
        );
      }
      this.members_options = members.map(member => ({
        value: member.id_member,
        label: member.name,
        code_cpt: member.code_cpt,
        code_gda: member.code_gda,
      }));

      this.selected_member = Number(this.$route.params.id)
      this.download_url = ANNEXII_ENDPOINTS.download_annexii(
        this.$route.params.campaignId, this.$route.params.id
      )

      const {data} = await CampaignServices.fetchCampaignMember(this.$route.params.campaignId, this.$route.params.id);
      this.campaign_member = data

      this.annexeii_origin_data = await AnnexIIService.getAnnexIByCampaignMember(this.$route.params.campaignId, this.$route.params.id);
      this.selected_view = this.branches_nav[0]
      this.is_loading = true;
      this.filterAnnexeIIDataByView()
      this.is_loading = false;
    },
    filterAnnexeIIDataByView() {
      this.table_loading = true;
      this.annexeii_data = this.annexeii_origin_data.filter(item => item.branch === this.selected_view.french)
      Object.values(this.filter_table_data).forEach((column_data) => {
        if (column_data.value && column_data.value !== '') {
          this.annexeii_data = this.annexeii_data.filter(
            annexeii_data => String(annexeii_data[column_data.field]).includes(String(column_data.value))
          )
        }
      })
      this.table_loading = false;
    },
    validateAnnexeIIData(annexeii_data) {
      return !annexeii_data.map(
        data => isNaN(parseFloat(data.insured_sum)) || isNaN(parseFloat(data.issued_prime)) || isNaN(parseFloat(data.police_number))
      ).some(is_nan => is_nan)
    },
    async saveAnnexeII() {
      if (!this.validateAnnexeIIData(this.annexeii_origin_data)) {
        alert(this.$t("Table have to contain only numeric values"), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })

        return
      }

      if (await AnnexIIService.createAnnexii({
        annexeii_data: this.annexeii_origin_data.map(data => ({
          ...data,
          insured_sum: parseFloat(data.insured_sum),
          issued_prime: parseFloat(data.issued_prime),
          police_number: parseFloat(data.police_number),
        })),
        id_campaign: this.$route.params.campaignId,
        id_member: this.$route.params.id,
      })) {
        alert(this.$t('Successfuly saved Appendix II data'), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })

      } else {
        alert(this.$t('Something went wrong'), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })

      }
    }
  }
}
</script>

<style>
.custom-border-bottom {
  border-bottom: 2px solid #23145f;
}

.on-mouse-hover:hover {
  cursor: pointer;
}

.arrow-buttons {
  display: none;
}
</style>
